import React, { useEffect } from 'react';
import { useState } from 'react';
import InstructionContainer from '../../containers/ChainReactionGame/InstructionContainer';
import Counter from '../Counter';

import './BettingPanel.css';
import BettingPanelInstructions from './BettingPanelInstrucitons';
import BettingPanelOverlay from './BettingPanelOverlay';
import BettingPanelWizardInstructionsOverlay from './BettingPanelWizardInstructionsOverlay';

const BettingPanel = props => {

	const { points, bet, addBet, setBet, betLocked, isLinkSelected, isAllowHintOnFocusLink, reloadPoints, revealAnswer, quitGame, showHint, setGameResetStatus, openInstrOverlay, isRevealAnswers } = props;

	const [notEnoughPoints, setNotEnoughPoints] = useState(points===0);
	const [initialLoad, setInitialLoad] = useState(true);
	const [showOverlay, setShowOverlay] = useState(false);

	const hasBet = bet>0,
		betPanelClassName = (betLocked?" locked":"") + (hasBet?" bet-selected":"") + (showOverlay==='instructions-overlay' || showOverlay==='select-chain-overlay' || isRevealAnswers?" contained-overlay":""),
		betDisplayClassName =  (betLocked?" locked":"");

	const coinDemination = [50, 100, 200];
	const hbClassName = (isLinkSelected && isAllowHintOnFocusLink) ? ' enable': '';

	const handleCloseInstructions = evt => {
		setShowOverlay(false);
		setGameResetStatus();
	}

	const handleOpenInstructions = evt => {
		setShowOverlay('instructions-overlay');
	}

	const placeBet = dem => {

		const func = addBet(dem);
		
		return evt=>{ 

			if (dem > points) {
				setNotEnoughPoints(true);
			} else {
				setNotEnoughPoints(false);
			}

			setInitialLoad(false);

			func(evt);
		};
	}

	useEffect(()=>{
		if (hasBet) {
			setShowOverlay('select-chain-overlay');
		}
	},[bet]);

	useEffect(()=>{

		if(points===0 && !betLocked) {
			setNotEnoughPoints(true);
		} else {
			setNotEnoughPoints(false);
			setShowOverlay('reset-not-enough-points');
		}

	}, [points, betLocked]);

	useEffect(()=>{

		if (notEnoughPoints) {
			setShowOverlay('game-point-options-overlay');
		}
	},[notEnoughPoints])

	useEffect(()=>{

		if (showOverlay==='reset-not-enough-points') {
			setNotEnoughPoints(false);
		} 
	},[showOverlay])
	
	useEffect(()=>{
		if (openInstrOverlay) {
			handleOpenInstructions();
		}
	}, [openInstrOverlay])

	return (
		<div className={"crg-betting-panel" + betPanelClassName}>
			<InstructionContainer />
			<div className="crg-coin-container">
				{coinDemination.map(dem=>(<a key={"coin-"+dem} onClick={placeBet(dem)} className={"coin coin-"+dem+((bet>0&&bet==dem)?' selected':'')}>{dem}</a>))}
			</div>
			{/* <a onClick={setBet(0)} className="clear-bet">Clear Bet</a> */}
			<div className="crg-bp-points-container">
				Points: 
				<span className={"crg-bet-display" + betDisplayClassName}>
					<Counter count={points} hideAnimation={initialLoad}/>
				</span>
				{/* <p className="instr">You need 1000 points to Win the Game.</p> */}
			</div>
			<a onClick={showHint} className={"hint-btn" + hbClassName}>Need a Hint</a>
			<div className="crg-instructions-icon-container">
				<span onClick={handleOpenInstructions}>?</span>
			</div>
			{showOverlay==='game-point-options-overlay' &&
				<BettingPanelOverlay
					revealAnswer={revealAnswer}
					reloadPoints={reloadPoints}
					quitGame={quitGame}
					showOverlay={setShowOverlay}
					hasPoints={points > 0}
				/>
			}
			{showOverlay==='instructions-overlay' &&
				<BettingPanelInstructions
					handleCloseInstructions={handleCloseInstructions}
				/>
			}
			{(showOverlay==='select-chain-overlay' || isRevealAnswers) &&
				<BettingPanelWizardInstructionsOverlay
					showBlankOverlay={isRevealAnswers}
				/>
			}
		</div>
		);
}

export default BettingPanel;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/BettingPanel.jsx